export const getBrands = state => state.brands;

export const getPolicies = state => state.policies;

export const getIsLoading = state => state.isLoading;

export const getError = state => state.error;

export const getModels = state => state.models;

export const getCalculationResult = state => state.calculationResult;
